import "./Booking.css";

function Booking() {

  return (

    <div className="Booking">
      <a className="BookingBtn" href='https://app.squareup.com/appointments/book/o19iiyl21y6sb9/LDC97V2TB6YBH/start' aria-label='Booking an apoitment via Squareup' target='_blank' rel="noreferrer">Book Now</a>
    </div>
  )
}

export default Booking